import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import NotificationPreview from '../../../components/NotificationPreview/NotificationPreview';
import { ERRORS } from '../../../constants/AppConstants';
import { getShippingAlertData, updateShippingAlertData } from '../../../services/woocommerceService';

const WooShippingNotification = () => {

    const { selectedWebsite,
        setIsDirty,
        setPathToNavigate,
        setDiscardPromptOpen,
        isDirty, 
    } = useAppContext();

    const history = useHistory();

    const [shipping, setShipping] = useState()

    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(null);

    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState(null);
    const [messageLengthError, setMessageLengthError] = useState(null);

    useEffect(() => {
        const discard = () => {
            setShippingData(shipping);
        }
        document.addEventListener('discardEvent', discard);

        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [shipping])

    useQuery(
        ['fetchWooShippingNotification', selectedWebsite?.id], 
        () => getShippingAlertData(selectedWebsite?.id),
        {
            enabled: !!selectedWebsite,
            onSuccess: (shippingNotificationData) => {
                if(shippingNotificationData) {
                    setShipping(shippingNotificationData);
                    setShippingData(shippingNotificationData);
                } else {
                    toast.error('Something went wrong!!');
                }
            }
        }
    )

    const handelTitleChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setTitleError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 100 ) {
            setTitle(value);
        }
    }

    const handelMessageChange = (value) => {
        
        if(value.trim().length > 120 ) {
            setMessageLengthError(ERRORS.WEBSITE_MESSAGE_MAX_LENGTH);
        }
        else {
            setMessageLengthError(null)
            setMessageError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 300 ) {
            setMessage(value);
        }
    }

    const onBack = () => {
        if(isDirty) {
        setPathToNavigate('/woocommerce-automation');
        setDiscardPromptOpen(true);
        } else {
            history.push('/woocommerce-automation');
        }
    }

    const setShippingData = (shippingNotificationData) => {
        setTitle(shippingNotificationData?.title);
        setMessage(shippingNotificationData?.message);
    }

    const updateShippingNotification = useMutation((event) => {
        event.preventDefault();
        const shippingData = {
            title,
            message,
        };
        return updateShippingAlertData(selectedWebsite?.id, shippingData)},
        {
            onSuccess: (shippingNotificationData) => {
                setShipping(shippingNotificationData);
                setShippingData(shippingNotificationData);
                setIsDirty(false);
                toast.success('Shipping Notification details updated successfully');
            }
        }
    );

    const isSaveDisabled = () => {
        return title.length <= 0  || titleError || messageError ;
    }

    const discard = () => {
        setDiscardPromptOpen(true);
    }


    return <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div>
                    <h3 className="mb-0">
                        <i className="icon icon-chevron-left mr-2" onClick={onBack} ></i> 
                        Shipping Notification Settings</h3>
                    </div>
                    <div className="d-flex justify-content-between">
                        <button className="btn btn-sm btn-danger mr-2" onClick={discard} >Discard</button>
                        <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={updateShippingNotification.mutate} >Save</button>                                         
                    </div> 
                </div>                                 
            </div>
            <div className="panel-body full-height scrollable_y">
                <div className="row">
                    <div className="col br-right">
                    <div className="form-group">
                            <div className="d-flex justify-content-between">
                                <label className="form-label text-dark medium">Title *</label>
                                <div>{title.length} / 100</div>
                            </div>
                            <div className="input-addon input-group-right">
                                <i className="icon icon-edit"></i>
                                <input
                                    type="text"
                                    placeholder="Your order [order_name] has been sent"
                                    className="form-control"
                                    value={title}
                                    onChange={({target}) => handelTitleChange(target.value)}
                                    maxLength={100}    
                                />                        
                            </div>
                            <span>Note: You can use the [order_name] keyword as placeholder that will be dynamically replaced with the real value.</span>
                            { titleError && <div><span className="error-message">{titleError}</span></div>}
                        </div>
                    <div className="form-group">
                        <div className="d-flex justify-content-between">
                            <label className="form-label text-dark medium">Custom Message</label>
                            <div>{message.length} / 300</div>
                        </div>
                        <div className="input-addon input-group-right">
                            <i className="icon icon-edit"></i>
                            <input
                                type="text"
                                placeholder="Click here to track your order"
                                className="form-control"
                                value={message}
                                onChange={({target}) => handelMessageChange(target.value)}    
                                maxLength={300}
                            />                        
                        </div>
                        <span>Note: The welcome message is displayed to the user.</span>
                        { messageError && <div><span className="error-message">{messageError}</span></div>}
                        { messageLengthError && <div><span className="error-message">{messageLengthError}</span></div>}
                    </div>
                    {/* <div className="form-group">
                        <div className="d-flex justify-content-between">
                            <label className="form-label text-dark medium">Primary Link</label>
                            <div>{landing_url.length} / 150</div>
                        </div>
                        <div className="input-addon input-group-right">
                            <i className="icon icon-edit"></i>
                            <input 
                                type="text" 
                                className="form-control"
                                value={landing_url}
                                onChange={({target}) => handelWelcomeLinkChange(target.value)}
                                maxLength={150}
                            />                        
                        </div>
                        <span>Note: You can send a visitor to a particular link upon clicking the notification. If left empty, they will land on your home page. (Optional)</span>
                        { welcomeLinkError && <div><span className="error-message">{welcomeLinkError}</span></div>}
                    </div>
                    <label className="form-label">Button 1</label>
                        <div className="form-row">
                            <div className="col">                                                
                                <input type="text" className="form-control" placeholder="Track Order" />
                                </div>
                                <div className="col">                                                
                                <input type="text" className="form-control" placeholder="Primary link" />
                                </div>
                        </div>
                    <button className="btn btn-grey my-4"><i className="icon icon-add"></i>Add Button</button> */}
                    </div>
                    <NotificationPreview
                        title={title}
                        message={message}
                        icon={selectedWebsite?.logo}
                        is_cta_enabled = {false}
                        isCTA2Enabled = {false}
                        button={''}
                        addl_button={''}
                    />
                    </div>
                </div>
            </div>
    </>
}

export default WooShippingNotification;